import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { getAllordersAsync, updateDeliveryStatusAsync } from "../async.api";

const initialState = {
  orderLoader: false,
  orders: [],
  updateStatus: [],
};

export const orderSlice = createSlice({
  name: "orders",
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(
      isAnyOf(getAllordersAsync.pending, updateDeliveryStatusAsync.pending),
      (state) => {
        state.orderLoader = true;
      }
    );

    builder.addMatcher(
      isAnyOf(updateDeliveryStatusAsync.fulfilled),
      (state, action) => {
        state.orderLoader = false;
        state.updateStatus = action.payload;
      }
    );

    builder.addMatcher(
      isAnyOf(getAllordersAsync.fulfilled),
      (state, action) => {
        state.orderLoader = false;
        state.orders = action.payload;
      }
    );
    builder.addMatcher(
      isAnyOf(getAllordersAsync.rejected, updateDeliveryStatusAsync.rejected),
      (state, action) => {
        state.orderLoader = false;
      }
    );
  },
  reducers: {
    emptyorders: (state) => {
      return {
        ...initialState,
      };
    },
  },
});

export const { emptyorders } = orderSlice.actions;

export default orderSlice.reducer;
